/**
 * This file serves as the entry point to the client-side application logic
 * It bootstraps the Common Module when the page is finished loading
 */

/* eslint-disable no-unused-vars */

import jqueryValidation from 'jquery-validation';
import jqueryValidationUnobtrusive from 'jquery-validation-unobtrusive';
import $ from './lib/jquery'; // Only need to import index.js because we expose it globally
import Module from './lib/module';
import Util from './lib/util';
import Slider from './slider';
import Navigation from './navigation';

import ComponentLoader from './admin/components/component-loader';
import PortalComponentLoader from './portal/components/component-loader';

Util.ensureJQuery();

$().ready(() => {
  $('.js-form').validate();
  Module.loadAll({ async: true });
  Slider.slider();
  ComponentLoader.loadComponents();
  PortalComponentLoader.loadComponents();
  Navigation.initMobileNavigationScrollLockEventListener();

  // add a small delay to the animations, don't animate immediately onload
  setTimeout(() => {
    $('body').addClass('animated-app');
  }, 1000);
});
